<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div v-if="datas">
    <div class="row">
      <div class="col-sm-6 col-md-4 grid-margin mb-0">
        <div
          class="card home-top-card"
          v-b-tooltip
          title="Nombre de transaction en attente"
        >
          <div class="card-body">
            <div class="pt-2 pb-3">
              <v-icon large style="color: #ffa53e">mdi-progress-alert</v-icon>
              <span
                class="float-right mt-2 home_top_number"
                style="font-size: 13pt !important"
              >
                {{
                  datas.pending_transactions ? datas.pending_transactions : 0
                }}</span
              >
            </div>
            <h2 class="card-title">{{ $t("transaction_pending") }}</h2>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-4 grid-margin mb-0">
        <div
          class="card home-top-card"
          v-b-tooltip
          title="Nombre de transaction échouée"
        >
          <div class="card-body">
            <div class="pt-2 pb-3">
              <v-icon large style="color: #f40c0c">mdi-progress-close</v-icon>
              <span
                class="float-right mt-2 home_top_number"
                style="font-size: 13pt !important"
                >{{
                  datas.failed_transactions ? datas.failed_transactions : 0
                }}</span
              >
            </div>

            <h2 class="card-title">{{ $t("transaction_failed") }}</h2>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-md-4 grid-margin mb-0">
        <div
          class="card home-top-card"
          v-b-tooltip
          title="Nombre de transaction réussis"
        >
          <div class="card-body">
            <div class="pt-2 pb-3">
              <v-icon large style="color: #61ae7a">mdi-progress-check</v-icon>
              <span
                class="float-right mt-2 home_top_number"
                style="font-size: 13pt !important"
                >{{
                  datas.success_transactions ? datas.success_transactions : 0
                }}</span
              >
            </div>

            <h2 class="card-title">{{ $t("transaction_success") }}</h2>
          </div>
        </div>
      </div>
      <div
        v-if="
          wallets &&
          !this.$store.getters.auth.role._code.toLowerCase().includes('admin')
        "
        class="col-sm-6 col-md-4 grid-margin mb-0 pt-0"
      >
        <div
          class="card home-top-card"
          style="color: white; background: transparent; box-shadow: none"
        >
          <div
            class="card-body mb-0"
            v-b-tooltip
            :title="$t('wallet_total_title')"
            style="
              background: #29b3a6;
              padding-top: 10px !important;
              padding-bottom: 5px !important;
              border-radius: 3px;
            "
          >
            <h2 style="font-size: 10pt !important" class="text-uppercase">
              {{ $t("wallet_total") }}
            </h2>
            <div class="">
              <v-icon small color="white">mdi-currency-usd</v-icon>
              <span v-if="$store.getters.marchand && wallets.marchand_wallet">
                <span
                  class="float-right home_top_number"
                  style="font-size: 10pt !important"
                >
                  {{
                    datas.agregates.success &&
                    !isNaN(datas.agregates.success.totalAmount)
                      ? formatAmount(datas.agregates.success.totalAmount)
                      : "0"
                  }}
                  {{ wallets.marchand_wallet.devise._code_alpha }}
                </span>
              </span>
              <span
                class="float-right home_top_number"
                style="font-size: 10pt !important"
                v-else
              >
                0
              </span>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="
          wallets &&
          !this.$store.getters.auth.role._code.toLowerCase().includes('admin')
        "
        class="col-sm-6 col-md-4 grid-margin mb-0 pt-0"
      >
        <div
          class="card home-top-card"
          style="color: white; background: transparent; box-shadow: none"
        >
          <div
            class="card-body mb-0 mt-0"
            v-b-tooltip
            :title="$t('wallet_actif_title')"
            style="
              background: #29b3a6;
              padding-top: 10px !important;
              padding-bottom: 5px !important;
              border-radius: 3px;
            "
          >
            <h2 style="font-size: 10pt !important" class="text-uppercase">
              {{ $t("wallet_actif") }}
            </h2>

            <div class="">
              <v-icon small color="white">mdi-currency-usd</v-icon>
              <span v-if="$store.getters.marchand && wallets.marchand_wallet">
                <span
                  v-if="$store.getters.marchand._env === 'live'"
                  class="float-right home_top_number"
                  style="font-size: 10pt !important"
                  >{{
                    wallets.marchand_wallet &&
                    !isNaN(wallets.marchand_wallet._amount)
                      ? formatAmount(wallets.marchand_wallet._amount)
                      : "0"
                  }}
                  {{ wallets.marchand_wallet.devise._code_alpha }}</span
                >
                <span
                  v-else
                  class="float-right home_top_number"
                  style="font-size: 10pt !important"
                  >{{
                    wallets.marchand_wallet &&
                    !isNaN(wallets.marchand_wallet._sandbox_amount)
                      ? formatAmount(wallets.marchand_wallet._sandbox_amount)
                      : "0"
                  }}
                  {{ wallets.marchand_wallet.devise._code_alpha }}</span
                >
              </span>
              <span
                class="float-right home_top_number"
                style="font-size: 10pt !important"
                v-else
              >
                0
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="
          wallets &&
          !this.$store.getters.auth.role._code.toLowerCase().includes('admin')
        "
        class="col-sm-6 col-md-4 grid-margin mb-0 pt-0"
      >
        <div
          class="card home-top-card"
          style="color: white; background: transparent; box-shadow: none"
        >
          <div
            class="card-body mb-0 mt-0"
            v-b-tooltip
            :title="$t('wallet_waiting_title')"
            style="
              background: #29b3a6;
              padding-top: 10px !important;
              padding-bottom: 5px !important;
              border-radius: 3px;
            "
          >
            <h2 style="font-size: 10pt !important" class="text-uppercase">
              {{ $t("wallet_waiting") }}
            </h2>

            <div class="">
              <v-icon small color="white">mdi-currency-usd</v-icon>
              <span v-if="$store.getters.marchand && wallets.marchand_wallet">
                <span
                  v-if="$store.getters.marchand._env === 'live'"
                  class="float-right home_top_number"
                  style="font-size: 10pt !important"
                  >{{
                    wallets.marchand_wallet &&
                    !isNaN(wallets.marchand_wallet._waiting_amount)
                      ? formatAmount(wallets.marchand_wallet._waiting_amount)
                      : "0"
                  }}
                  {{ wallets.marchand_wallet.devise._code_alpha }}</span
                >
                <span
                  v-else
                  class="float-right home_top_number"
                  style="font-size: 10pt !important"
                  >{{
                    wallets.marchand_wallet &&
                    !isNaN(wallets.marchand_wallet._sandbox_waiting_amount)
                      ? formatAmount(
                          wallets.marchand_wallet._sandbox_waiting_amount
                        )
                      : "0"
                  }}
                  {{ wallets.marchand_wallet.devise._code_alpha }}</span
                >
              </span>
              <span
                class="float-right home_top_number"
                style="font-size: 10pt !important"
                v-else
              >
                0
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 col-lg-12">
        <div v-if="$store.getters.marchand || $store.getters.isAdmin">
          <h2
            class="card-title col-12 col-lg-12 col-md-12 mb-0"
            style="background: white"
          >
            Transactions récentes
          </h2>
          <v-data-table
            hide-default-footer
            :headers="headers"
            :items="datas.latest_transactions"
            class="elevation-1"
            :loading="!datas"
          >
            <template v-slot:item._type="{ item }">
              <v-icon color="success" style="margin-right: 2px"
                >mdi-arrow-bottom-left</v-icon
              >
              <span class="text-lowercase">{{ item._type }}</span>
            </template>
            <template v-slot:item.mean="{ item }">
              <div v-if="item.mean">
                <img
                  :title="item.mean._name + ' ' + item.mean._country._name"
                  v-if="item.mean"
                  :src="item.mean._file.substr(7)"
                  style="width: 40px"
                  alt=""
                />
              </div>
              <div v-else>
                <h6>en attente</h6>
              </div>
              <!--<v-chip class="text-white" small color="dark">{{(item.mean)?item.mean._name+' '+item.mean._country._name:'-'}}</v-chip>-->
            </template>
            <template v-slot:item._amount="{ item }">
              {{ formatAmount(item._amount) }} {{ item.x_currency._code_alpha }}
            </template>
            <template v-slot:item._num_source="{ item }">
              <span v-if="item._num_source">
                {{ item._num_source }}
              </span>
              <span v-else> en attente </span>
            </template>

            <template v-slot:item._status="{ item }">
              <v-chip
                class="text-white"
                small
                :color="getStatusColor(item._status).color"
                >{{ getStatusColor(item._status).status }}</v-chip
              >
            </template>
            <template v-slot:item._created_at="{ item }">
              {{ getDate(item._created_at) }}
            </template>
            <template v-slot:item.action="{ item }">
              <div class="text-right">
                <router-link
                  style="text-decoration: none"
                  :to="'/transactions/details/' + item._id"
                >
                  <v-btn outlined color="primary" small>Consulter</v-btn>
                </router-link>
              </div>
            </template>
            <template v-slot:no-data>
              <span>{{ $t("no_data") }}</span>
            </template>
          </v-data-table>
        </div>
        <div v-else>
          <go-to-params></go-to-params>
        </div>
      </div>
    </div>
    <div
      class="col-12"
      v-if="$store.getters.marchand || $store.getters.isAdmin"
    >
      <div class="row">
        <paycfa-charts></paycfa-charts>
      </div>
    </div>
    <div v-else>
      <ModalNewCompte></ModalNewCompte>
    </div>
  </div>
  <div
    v-else
    class="col-lg-12 col-md-12 col-12 text-center loader_panel_component"
  >
    <img src="/loaders/loader_turq.gif" alt="" /><br />
    <span class="loader_text"> {{ $t("page_loading") }} ... </span>
  </div>
</template>

<script>
import { mapState } from "vuex";
import helpers from "../../mixins/helpers";
import * as Swal from "sweetalert2";
import GoToParams from "./globalComponents/GoToParams";
import ModalNewCompte from "./ModalNewCompte";

export default {
  name: "Home",
  components: { ModalNewCompte, GoToParams },
  mixins: [helpers(this)],
  data() {
    return {
      pageTitle: "BORD",
      headers: [
        { text: "Type", value: "_type" },
        { text: "Statut", value: "_status" },
        { text: "Source", value: "mean" },
        { text: "Montant", value: "_amount" },
        { text: "Numéro", value: "_num_source" },
        { text: "Date", value: "_created_at" },
        { text: "", value: "action" },
      ],
      editedItem: {
        _marchandID: "",
        _created_at: 0,
        _id: "",
      },
      defaultItem: {
        _marchandID: "",
        _created_at: 0,
        _id: "",
      },
    };
  },
  mounted() {
    let vueBox = this;
    if (this.$store.getters.marchand) {
      this.marchandexiste = true;
    }
    this.$store.dispatch("dashboard/index").then(() => {
      vueBox.$store.dispatch("dashboard/wallets").then(() => {
        vueBox.$store
          .dispatch("marchands/getMarchandUser")
          .then((merchantresponse) => {
            console.log("liste marchands dashbord home", merchantresponse);
            vueBox.$store
              .dispatch("means_paiements/getMeans_paiements")
              .then(() => {
                let data = new FormData();
                data.append("id", this.$store.getters.auth._id);
                vueBox.$store.dispatch(
                  "user_means_paiements/getUser_means_paiements",
                  data
                );
              });
          });
      });
    });
  },
  computed: {
    ...mapState("means_paiements/", ["means_paiements"]),
    ...mapState("dashboard", ["datas"]),
    ...mapState("dashboard", ["wallets"]),
    ...mapState("marchands/", ["marchandu"]),
    ...mapState("user_means_paiements/", ["user_means_paiements"]),

    user: function () {
      return this.$store.getters.auth;
    },
  },
  methods: {
    getCompanyName() {
      return this.$store.getters.marchand
        ? this.setTextToUpperCase(this.$store.getters.marchand._company)
        : "-";
    },
    checkisDashboard() {
      this.$emit("checkisDashboard", true);
    },

    ChangedMarchand() {
      Swal.fire({
        icon: "warning",
        timerProgressBar: false,
        text: this.$t("marchand.change_marchand"),
        confirmButtonText: "Oui",
        cancelButtonText: "Non",
        showCancelButton: true,
        confirmButtonColor: "#29B3A6",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("marchands/changeMarchand", this.editedItem._marchandID)
            .then(() => {
              Swal.fire({
                icon: "success",
                timer: 3000,
                timerProgressBar: false,
                text: "Changement de compte effectué",
                position: "top-end",
                showConfirmButton: false,
              });
              window.location = window.origin;
            });
        }
      });
    },
    getUserNames() {
      let names = undefined;
      if (
        !(
          this.$store.getters.auth._first_name &&
          this.$store.getters.auth._last_name
        )
      ) {
        if (!this.$store.getters.auth._first_name) {
          if (this.$store.getters.auth._last_name) {
            names = this.$store.getters.auth._last_name;
          }
        } else {
          names = this.$store.getters.auth._first_name;
        }
      } else {
        names =
          this.$store.getters.auth._first_name +
          " " +
          this.$store.getters.auth._last_name;
      }
      return names;
    },
  },
  created() {
    this.checkisDashboard();
  },
};
</script>

<style>
.notification_box {
  margin-top: 20px !important;
}
</style>
